import { mixed, object, string, boolean } from "yup"
import { isEUCountry, isGermanCountry } from "entities/country"
import { BILLING_CURRENCIES } from "../lib"

export const billingAddressSchema = object({
  company: string().nullable().required("required"),
  department: string().nullable(),
  title: string().nullable(),
  first_name: string().required("required"),
  last_name: string().required("required"),
  gender: mixed()
    .transform((value) => value?.id)
    .oneOf(["male", "female", "unisex"])
    .required("required"),
  salutation: string().nullable().required("required"),
  ust_vat: string()
    .nullable()
    .when(["country", "without_vat_id"], {
      is: (country, without_vat_id) => {
        const countryCode = country?.id || country
        return (
          isEUCountry(countryCode) &&
          !isGermanCountry(countryCode) &&
          !without_vat_id
        )
      },
      then: (schema) => schema.required("required"),
      otherwise: (schema) => schema.nullable()
    }),
  without_vat_id: boolean(),
  street: string().required("required"),
  street_number: string().required("required"),
  country: mixed()
    .transform((value) => value?.id)
    .required("required"),
  zip: mixed()
    .transform((value) => value?.zip_code)
    .nullable()
    .required("required"),
  city: mixed()
    .transform((value) => value?.city)
    .nullable()
    .required("required"),
  is_default: boolean(),
  currency: string().oneOf(BILLING_CURRENCIES).required("required")
})
